import { useMemo } from "react"

export const useAllowedPaymentMethodTypes = (event) => {
  return useMemo(() => {
    if (
      event.onlinePaymentMethods?.length === 0 &&
      event.allowCreditCardPayments
    ) {
      return ["card"]
    }

    return event.onlinePaymentMethods
  }, [event.onlinePaymentMethods, event.allowCreditCardPayments])
}
